import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface TrayExtraProps {
  onAddClick(): void
}

const TrayExtra = ({
  onAddClick,
}: TrayExtraProps): JSX.Element => (
  <MainContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Cadastrar unidade produtiva
    </Button>
  </MainContainer>
);

export default TrayExtra;
